import { render, staticRenderFns } from "./CardImage.vue?vue&type=template&id=71fb22ff&scoped=true&"
import script from "./CardImage.vue?vue&type=script&lang=ts&"
export * from "./CardImage.vue?vue&type=script&lang=ts&"
import style0 from "./CardImage.vue?vue&type=style&index=0&id=71fb22ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb22ff",
  null
  
)

export default component.exports